module.exports = __webpack_public_path__ + "static/media/5-Thuiskok-foto1.9ec0dad9.jpg";